export const DEFAULT_BUSINESS_CASE_COLD_THRESHOLD_DAYS = 7;
